/* OutageError.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { ErrorFooter, ErrorTemplate } from '../ErrorTemplate';
import { locale } from '../locale';
import { StatusLink, SupportLink } from '../RedirectLinks';
import OutageErrorSvg from './OutageError.svg';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _4 = "._1tke1kw7{min-height:inherit}";
const _3 = "._2lx21bp4{flex-direction:column}";
const _2 = "._1e0c1txw{display:flex}";
const _ = "._1yt4pxbi{padding:var(--ds-space-200,1pc)}";
const OutageErrorWrapper = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt4pxbi _1e0c1txw _2lx21bp4 _1tke1kw7", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  OutageErrorWrapper.displayName = 'OutageErrorWrapper';
}
export const OutageError = () => {
  return /*#__PURE__*/_jsx(OutageErrorWrapper, {
    children: /*#__PURE__*/_jsxs(ErrorTemplate, {
      heading: locale.outage.heading,
      image: OutageErrorSvg,
      children: [locale.outage.teamInvestigatingIssue, /*#__PURE__*/_jsx(StatusLink, {}), /*#__PURE__*/_jsxs(ErrorFooter, {
        children: [locale.outage.urgentAssistance, " ", /*#__PURE__*/_jsx(SupportLink, {
          children: locale.contactSupport
        }), "."]
      })]
    })
  });
};